import { useEffect } from "react";
import { useSideNavContext } from "src/components/layout/SideNavContext";

/**
 * Hides the project SideNav while mounted, then restores it on cleanup.
 *
 * Prefer declaring the route outside `ProjectSideNavLayout` (under `ScrollableParentLayout`)
 * when the whole URL should never show SideNav. Keep this hook only when SideNav presence is
 * runtime-gated (e.g. invoice create vs editor on the same path) or nested inside a parent
 * route that still needs SideNav for sibling paths (e.g. draft schedule publish).
 */
export function useHiddenProjectSideNav() {
  const { setSideNavState } = useSideNavContext();
  useEffect(() => {
    setSideNavState("hidden");
    return () => setSideNavState("expanded");
  }, [setSideNavState]);
}
